import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentColor" stroke="currentColor" strokeWidth="1.5" d="M2.75 2.75h18.5v18.5H2.75z" /><path fillRule="evenodd" clipRule="evenodd" d="M18 8.529L9.993 16.5 6 12.548l1.052-1.029 2.94 2.923L16.949 7.5 18 8.529z" fill="#fff" /></svg>);